import React from 'react'

export const AttendanceCard = ({ attendanceData, weekData }) => {
  return (
    <div
      className={`p-3 h-[250px] flex flex-col gap-2 justify-start bg-[#238B45] border rounded-[5px]`}
    >
      <div className='flex-col'>
        <span className='font-medium text-[20px] text-white '>
          {attendanceData.title}
        </span>
      </div>
      <div className='bg-white h-[2px] w-full'> </div>
      <div className='flex flex-col gap-3 justify-between pb-5'>
        <div className='flex gap-2 justify-between w-full'>
          {weekData?.map(({ day, date, isToday }) => (
            <div
              key={date}
              className={`flex flex-col items-center gap-2 justify-center w-12 h-[65px]  rounded-md ${
                isToday ? 'bg-white  font-medium' : ''
              }`}
            >
              <span className={`${isToday ? 'text-black' : 'text-[#D2D2D7]'}`}>
                {day}
              </span>
              <span className={`${isToday ? 'text-black' : 'text-[#D2D2D7]'}`}>
                {date}
              </span>
            </div>
          ))}
        </div>
        <div className='flex justify-between items-center'>
          <div className='flex flex-col items-center justify-center pr-3 w-[100px]'>
            <div className='text-center font-medium text-[20px] text-white'>
              {attendanceData.present.value}
            </div>
            <div className='flex items-center text-[14px] font-medium justify-center text-center text-white'>
              {attendanceData.present.name}
            </div>
          </div>
          <div className='flex flex-col items-center text-[14px] justify-center pr-3 w-[100px]'>
            <div className='text-center font-medium text-[20px] text-white'>
              {attendanceData.late.value}
            </div>
            <div className='flex items-center text-[14px] font-medium justify-center text-center text-white'>
              {attendanceData.late.name}
            </div>
          </div>
          <div className='flex flex-col items-center justify-center pr-3 w-[100px]'>
            <div className='text-center font-medium text-[20px] text-white'>
              {attendanceData.absent.value}
            </div>
            <div className='flex items-center text-[14px] font-medium justify-center text-center text-white'>
              {attendanceData.absent.name}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
